import {ref, watch} from 'vue';
import {defineStore} from 'pinia';

export const useAppDataStore = defineStore('appData', () => {
    let appData = ref({
      datepickerFlag: false,
      usersource: '',
      partnertarif: false,
      zipOptions: {},
      installation_address_zipOptions: {},
      addresses: {},
      addresses_installation: {},
      orderType: 'Online Bestellung',
      queryId: '',
      currentStep: 1,
      currentCompletedStep: 1,
      appPackages: {},
      reversedAppPackages: {},
      s1: {
        value: '',
        intValue: '',
        stepGtmValues: [],
        options: [
          {
            name: 'Für mich selbst',
            value: 'Für mich selbst',
            className: 'icon--user'
          },
          {
            name: 'Für jemand anderen',
            value: 'Für jemand anderen',
            className: 'icon--users'
          }
        ]
      },
      s2: {
        value: '',
        stepGtmValues: [],
        options: [],
        zipCodeErrorVisible: false
      },
      s3: {
        value: '',
        intValue: '',
        stepGtmValues: [],
        options: [
          { name: 'Ja', value: 'Ja', className: 'icon--check' },
          { name: 'Nein', value: 'Nein', className: 'icon--not-checked' },
          {
            name: 'beantragt',
            value: 'beantragt',
            className: 'icon--document-check'
          },
          { name: 'unklar', value: 'unklar', className: 'icon--question' }
        ]
      },
      s4: {
        value: '',
        intValue: '',
        stepGtmValues: [],
        options: [
          { name: 'Zuhause', value: 'Zuhause', className: 'icon--home' },
          {
            name: 'Zuhause und unterwegs',
            value: 'Zuhause und unterwegs',
            className: 'icon--on-way'
          },
          { name: 'unklar', value: 'unklar', className: 'icon--question' }
        ]
      },
      s5: {
        value: '',
        userSelectedPrice: 0, // Actual package price that the user has selected [Without partnertarif]
        stepGtmValues: [],
        mappedPackages: {
          basis: 1,
          komfort: 2,
          premium: 3
        }
      },
      s6: true,
      s7: {
        value: '',
        capacity: '',
        options: [
          { name: 'Nein, danke', value: false, className: 'icon--check' },
          { name: 'Wunschtermin', value: 'wunschtermin', className: 'icon--calendar-alt' },
          { name: 'Rückrufwunsch ', value: 'rückrufwunsch', className: 'icon--phone' }
        ],
        meeting_time: '',
        holiday: false
      },
      s8: false,
      postcodeKey: '',
      agree: false,
      erfahren: '',
      contact: {
        anrede: '',
        firstname: '',
        lastname: '',
        street: '',
        house_number: '',
        zip: '',
        zipOfContact: '',
        stadt: '',
        city: '',
        servicesID: '',
        region: '',
        phone: '',
        phone_prefix: '',
        email: '',
        meeting_times: '',
        meeting_times_input: '',
        meeting_times_api: '',
        meeting_times_api_ts: '',
        meeting_times_exceptions_not_api: '',
        public_holidays: [],
        termin_select: false,
        installation_address_anrede: '',
        installation_address_firstname: '',
        installation_address_lastname: '',
        installation_address_street: '',
        installation_address_house_number: '',
        installation_address_zipOfContact: '',
        installation_address_stadt: '',
        installation_address_phone: '',
        installation_address_phone_prefix: '',
        installation_address_email: ''
      },
      installation_address_checkbox: ref(true),
    })

    return {appData}

  }, {
    persist: { // pinia-plugin-persistedstate package config. Handles dynamic two-way data binding with localstorage
      enabled: true,
      key: `johanniter-data-new14_${BRAND_THEME}`,
    }
  },
)
